export function handleClassNames(elementClass, styles) {
    const classArray = elementClass.split(" ");
    const classNames = classArray.map((e) => {
        return `${styles[e]}`;
      });
      return `${classNames.join(' ')}`;
};